import React from "react";
import "./leftPanel.css";

const LeftPanel = () => {
    const menuItems = [
        { id: "home", label: "Home" },
        { id: "savedSearches", label: "Saved Searches" },
    ];

    return (
        <div className="left-panel">
            <h2>Dashboard</h2>
            <ul className="menu">
                {menuItems.map((item) => (
                    <li key={item.id} className="menu-item">
                        {item.label}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default LeftPanel;
